import { render } from "./ConvocationView.vue?vue&type=template&id=852e7498"
import script from "./ConvocationView.vue?vue&type=script&lang=js"
export * from "./ConvocationView.vue?vue&type=script&lang=js"

import "./ConvocationView.vue?vue&type=style&index=0&id=852e7498&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__